import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './styles.css';
import { useDatesModalAutoOpen } from './utils/useDatesModalAutoOpen';
import { Filters } from '../../../../packages/Filters';
import { checkIsHotelsSearch } from '../../../../packages/JsonQuery/utils/checkIsHotelsSearch';
import { Desktop, NotDesktop } from '../../../../packages/Responsive';
import { RedesignedFiltersPanelContainer } from '../../../FiltersMobile/containers';
import { FooterAdfoxBanner } from '../../../ListingDesktop/containers/FooterAdfoxBanner';
import { JournalHighlightsContainer } from '../../../ListingDesktop/containers/JournalHighlightsContainer';
import { RealtorRequestTrapContainer } from '../../../ListingDesktop/containers/RealtorRequestTrapContainer';
import { SeoCrossLinksContainer } from '../../../ListingDesktop/containers/SeoCrossLinks';
import { SidebarContainer } from '../../../ListingDesktop/containers/SidebarContainer';
import { ListingModalContainer } from '../../../ListingMobile/containers/ListingModal';
import { SeoMarkedListContainer } from '../../../ListingMobile/containers/SeoMarkedList/SeoMarkedListContainer';
import { Map } from '../../../Map/containers/Map';
import { EListingModalMode, EOffersFetchingMode, toggleModal } from '../../actions/listingModal';
import { PageLayout } from '../../components/PageLayout';
import { useIsDesktopFiltersMicrofrontendEnabled } from '../../hooks/useIsDesktopFiltersMicrofrontendEnabled';
import { useFiltersUxfbPoll } from '../../hooks/useUxFbPoll';
import { selectIsDesktopListingAvailable, selectIsDesktopListingVisible } from '../../selectors/desktopListing';
import { selectResultsJsonQuery } from '../../selectors/results';
import { TThunkDispatch } from '../../types/redux';
import { useApplicationContext } from '../ApplicationContext';
import { DesktopFiltersMicrofrontend } from '../DesktopFiltersMicrofrontend';
import { FiltersContainer } from '../FiltersContainer';
import { SaveSearchButtonContainer } from '../FiltersContainer/SaveSearchButton';
import { NavigationContainer } from '../Navigation';
import { Notifications } from '../Notifications';
import { useOfferHoverApi } from '../OfferHoverProvider';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';

export function PageContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const isDesktopListingVisible = useSelector(selectIsDesktopListingVisible);
  const isDesktopListingAvailable = useSelector(selectIsDesktopListingAvailable);
  const isHotelsSearch = checkIsHotelsSearch(jsonQuery);
  const showSaveSearchButton = !isHotelsSearch;
  const { setHoveredOfferId, resetHoveredOfferId } = useOfferHoverApi();
  const { config } = useApplicationContext();
  const isSeoEnabled = config.get<boolean>('dailyrent.seo.Enabled');

  const isDesktopFiltersMfEnabled = useIsDesktopFiltersMicrofrontendEnabled();

  useDatesModalAutoOpen();
  useFiltersUxfbPoll();

  React.useEffect(() => {
    dispatch(
      toggleModal({ open: true, mode: EListingModalMode.HALF_SCREEN, offersFetchingMode: EOffersFetchingMode.ALL }),
    );
  }, []);

  return (
    <>
      <PageLayout
        isSidebarOpened={isDesktopListingVisible}
        footer={
          isDesktopListingVisible &&
          isDesktopListingAvailable && (
            <Desktop>
              <RealtorRequestTrapContainer />
              <FooterAdfoxBanner />
              {isSeoEnabled && <JournalHighlightsContainer />}
              {isSeoEnabled && <SeoCrossLinksContainer />}
              {isSeoEnabled && <SeoMarkedListContainer />}
            </Desktop>
          )
        }
        map={<Map />}
        navigation={
          <FiltersContainer>
            <NotDesktop>
              <RedesignedFiltersPanelContainer />
            </NotDesktop>
            <Desktop>
              {isDesktopFiltersMfEnabled ? (
                <DesktopFiltersMicrofrontend />
              ) : (
                <Filters savedSearch={showSaveSearchButton && <SaveSearchButtonContainer />} />
              )}
              <NavigationContainer />
            </Desktop>
          </FiltersContainer>
        }
        sidebar={
          <FiltersContainer>
            <NotDesktop>
              <ListingModalContainer />
            </NotDesktop>
            <Desktop>
              {isDesktopListingAvailable && (
                <SidebarContainer onOfferMouseEnter={setHoveredOfferId} onOfferMouseLeave={resetHoveredOfferId} />
              )}
            </Desktop>
          </FiltersContainer>
        }
      />
      <SaveSearchModalContainer />
      <Notifications />
    </>
  );
}
